import { isServerError } from '@store/error';
import { type ReportImageStatus } from './ReportImagePicker';

const NOT_FOUND = 404;

/** Whether reading an image failed because the server has no such image, and not for another reason. */
export const isImageGone = (error: unknown): boolean => {
  const failure = { error };

  return isServerError(failure) && failure.error.status === NOT_FOUND;
};

/** How reading one stored image stands, for whoever shows it in a `ReportImagePicker`. */
interface StoredImage {
  /** The id the owner names the image by, or nothing where it names none. */
  imageId: string | undefined;
  /** An address the image can be shown from, once there is one. */
  picture: string | undefined;
  /** The server has answered that it holds no such image, to this read or to an earlier request. */
  gone: boolean;
  reading: boolean;
  /** What the read failed with, if it did. */
  error: unknown;
}

/** What the picker has to show for a stored image. */
export const storedImageStatus = ({ imageId, picture, gone, reading, error }: StoredImage): ReportImageStatus => {
  if (!imageId) return 'empty';
  if (gone) return 'missing';
  if (picture) return 'ready';

  // Any other failure says nothing about whether the image exists.
  return reading || !error ? 'loading' : 'unavailable';
};
